import React, { CSSProperties } from 'react';

import { withSelector } from '../../../../shared/index.js';
import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { IArrowIconProps } from '../models/IArrowIconProps.js';
import { TOOLTIP_CATEGORY_KEY, TOOLTIP_COMPONENT_KEY } from '../Tooltip.meta.js';

const pathStyle: CSSProperties = {
	fill: 'inherit',
	stroke: 'inherit',
	strokeWidth: '1px',
	strokeDasharray: '14,7,0',
};

const arrow = () => (
	<svg width="24px" height="24px" viewBox="0 0 24 24">
		<path className="arrow__path" d="M7,10L12,15L17,10H7Z" style={pathStyle} />
	</svg>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
const ArrowIcon = (props: IArrowIconProps) => {
	const { className, children, ...sectionProps } = props;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const Section: any = withSelector('section' as any, props);

	return (
		<Section className={className} {...sectionProps}>
			{arrow()}
		</Section>
	);
};

export default InjectedStyledComponent(ArrowIcon, TOOLTIP_CATEGORY_KEY, TOOLTIP_COMPONENT_KEY, ['arrowIcon']);
